import styled from 'styled-components/macro';

export const ResultRow = styled.tr`
  color: #000;
  border-bottom: 0.1rem solid #d8e8ef;

  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }

  &:hover {
    color: #7f7f7f;
  }
`;

ResultRow.displayName = 'ResultRow';

export const ResultsNameColumn = styled.td`
  color: #000;
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
`;

export const ResultsOrderNumber = styled.span`
  color: #5a75bb;
  font-family: lato, sans-serif;
  font-weight: 400;
`;

export const CustomMessage = styled.span`
  color: #08205e;
  font-family: lato, sans-serif;
  font-weight: 400;
`;
